import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

export default makeStyles(() => ({
  midia: {
    display: 'flex',
    flexDirection: 'column',
    padding: 10,
  },

  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    padding: 10,

    '& p': {
      padding: '5px 0 0 5px',

      '& span': {
        fontWeight: 600,
      },
    },
  },
  
  societaryParticipation:{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '1rem',
    '& > h3':{
      padding: '1rem 0',
    },
  },
  
  companiesList:{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '1rem',
    listStyle: 'none',
    paddingInlineStart: 5,
    '& > li':{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: '1rem',
      width: '100%',
    },
    '& > li > div:first-child': {
      width: '27px',
      height: '25px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 16,
      fontWeight: 500,
      color: Colors.loginPrimaryColor,
      borderRadius: '50%',
    },
    '& > li > div:last-child': {
      backgroundColor: '#EFEFEF',
      borderRadius: '4px',
      padding: '1.5rem',
      width: '100%',
    },
  },
  
  familyRelation:{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '1rem',
    '& > h3':{
      padding: '1rem 0 0.5rem',
    },
  },
  
  relativeList: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '1rem',
    listStyle: 'none',
    paddingInlineStart: 5,
  },
  
  relativeData: {
    display: 'flex',
    alignItems: 'center',
    width:'fit-content',
    gap: '1.5rem',
    backgroundColor: '#EFEFEF',
    borderRadius: '5px',
    padding: '1.5rem',
  },
  
  conflictCompaniesList: {
    listStyleType: 'disc',
    fontSize: 11,
  },
  
  dashedText: {
    textDecoration: 'line-through 1px solid',
  },

  score: {
    marginTop: 20,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& span': {
      fontSize: 14,
    },
  },

  expansibleContent: {
    padding: 10,
    backgroundColor: '#EFEFEF',
  },

  errorCaptured: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: 10,
    backgroundColor: '#EFEFEF',
  },

  restrictions: {
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },

  disclaimerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
  },
  processResumeDiv: {
    paddingLeft: 20,
    paddingBottom: 20,
    display: 'flex',
    flexDirection: 'column',
  },
}))
